class ApiQueueService {
  constructor() {
    this.queue = [];
    this.processing = false;
  }


  enqueue(apiCall) {
    return new Promise((resolve, reject) => {
      this.queue.push({
        apiCall,
        resolve,
        reject
      });

      // Start processing if not already processing
      if (!this.processing) {
        this.processQueue();
      }
    });
  }


  async processQueue() {
    if (this.queue.length === 0) {
      this.processing = false;
      return;
    }

    this.processing = true;
    const { apiCall, resolve, reject } = this.queue.shift();

    try {
      const result = await apiCall();
      resolve(result);
    } catch (error) {
      reject(error);
    } finally {
      // Process next item in queue
      this.processQueue();
    }
  }

  clear() {
    this.queue = [];
    this.processing = false;
  }

  getQueueLength() {
    return this.queue.length;
  }

  isProcessing() {
    return this.processing;
  }
}

const apiQueueService = new ApiQueueService();
export default apiQueueService;


